import { createContext, useContext, useState, useEffect, type ReactNode } from "react";

interface NeuroModeState {
  neuroMode: boolean;
  setNeuroMode: (v: boolean) => void;
}

const NeuroModeContext = createContext<NeuroModeState>({
  neuroMode: false,
  setNeuroMode: () => {},
});

export const useNeuroMode = () => useContext(NeuroModeContext);

export const NeuroModeProvider = ({ children }: { children: ReactNode }) => {
  const [neuroMode, setNeuroModeState] = useState(() => {
    try {
      return localStorage.getItem("captain_roca_neuro_mode") === "true";
    } catch {
      return false;
    }
  });

  const setNeuroMode = (v: boolean) => {
    setNeuroModeState(v);
    try {
      localStorage.setItem("captain_roca_neuro_mode", String(v));
    } catch {}
  };

  // Apply body classes globally
  useEffect(() => {
    const body = document.body;
    if (neuroMode) {
      body.classList.add("dyslexic-mode", "neuro-calm");
    } else {
      body.classList.remove("dyslexic-mode", "neuro-calm");
    }
  }, [neuroMode]);

  return (
    <NeuroModeContext.Provider value={{ neuroMode, setNeuroMode }}>
      {children}
    </NeuroModeContext.Provider>
  );
};
